import React from 'react';
import { Dialog } from '@material-ui/core';
import { ClosableDialogTitle } from 'components/ClosableDialog/ClosableDialogTitle';
import { ClosableDialogContent } from 'components/ClosableDialog/ClosableDialogContent';
import { ContactDetail } from './Detail';
import { Contact } from '../../Types';

interface ContactDetailModalProps {
  title: string,
  countryCode: string,
  onClose?: () => void,
  onSave?: (contact: Contact) => void,
  defaultData?: Contact,
  action?: string,
  contactId?: string,
}

function ContactDetailModal(props: ContactDetailModalProps) {
  const {
    title, countryCode, onClose, onSave, defaultData, action, contactId,
  } = props;

  return (
    <Dialog
      onClose={() => onClose?.()}
      aria-labelledby="customized-dialog-title"
      open
      fullWidth
      maxWidth={false}
      scroll="paper"
      disableBackdropClick
    >
      <ClosableDialogTitle onClose={() => onClose?.()}>
        {title}
      </ClosableDialogTitle>

      <ClosableDialogContent dividers>
        <ContactDetail
          contactId={contactId}
          action={action || 'add'}
          countryCode={countryCode}
          basicFields
          defaultData={defaultData}
          onClose={onClose}
          onSave={onSave}
        />
      </ClosableDialogContent>
    </Dialog>
  );
}

export {
  ContactDetailModal,
};
